import {defineStore} from 'pinia';
import {TextMsg} from 'common/types/tim.types';
import {getGroupProfile} from 'common/tim';
import config from 'site-config';

export const useTimStore = defineStore('tim', {
    state: () => ({
        tim: null,
        groupInfo: {
            like_num: '',
            like_num_str: '',
            join_num: '',
            float_img_url: '',
            float_jump_url: ''
        },
        messages: [] as Array<TextMsg>
    }),
    actions: {
        async initTim({tim, groupID}) {
            this.tim = tim;
            const groupInfo = await getGroupProfile({tim, groupID});
            if (groupInfo) {
                this.updateGroupInfo(groupInfo);
            }
        },
        addMessage(msg: TextMsg | Array<TextMsg>) {
            const messages = [...(Array.isArray(msg) ? msg : [msg]), ...this.messages];
            this.messages = messages.slice(0, config.TIM.LIMIT_MESSAGE_COUNT);
        },
        updateGroupInfo(info) {
            (info || []).forEach(item => {
                this.groupInfo[item.key] = item.value;
            });
        }
    }
});
